<template>
  <div class="FromLogin">
    <div class="binyi-toolbar">
      <img
        v-if="environment"
        class="binyi-toolbar-icon"
        src="@/assets/images/components/logo.png"
      />
      <img
        v-if="!environment"
        class="binyi-toolbar-icon"
        src="@/assets/images/components/logo_.png"
      />
      <span class="binyi-toolbar-name">中广{{environment?'家书':'训练'}}管理系统</span>
    </div>

    <div class="login_background">
      <div class="template-form-login-banner" v-if="environment">
        <img src="@/assets/images/UserLogin/bg2.png" />
      </div>

      <div class="template-form-login-banner_a" v-if="!environment">
        <img src="@/assets/images/UserLogin/bg2_.png" />
      </div>

      <div class="template-form-login-container-line"></div>

      <div class="template-form-login-container">
        <div class="login_title">
          <div class="login_welcome">欢迎登录</div>
          <img
            class="iv_triangle"
            src="@/assets/images/UserLogin/iv_triangle.png"
            alt=""
          />
        </div>
        <div class="login_title_line">
          <div class="login_title_line_blue"></div>
          <div class="login_title_line_gray"></div>
        </div>

        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="form_style"
        >
          <!-- <el-form-item prop="unit">
          <span class="icon">
            <img src="@/assets/images/UserLogin/icon-unit.png"/>
          </span>
          <span class="label">单位编码</span>
          <el-input v-model="ruleForm.unit" placeholder="请输入您的单位编码信息"></el-input>
        </el-form-item> -->

          <el-form-item prop="account">
            <div class="icon_all">
              <span class="icon">
                <img src="@/assets/images/UserLogin/icon-account.png" />
              </span>
              <span class="label">帐号</span>
            </div>
            <el-input
              v-model="ruleForm.account"
              placeholder="请输入帐号"
              maxlength="30"
              @input="
                (v) => {
                  this.ruleForm.account = v.replace(/[^a-zA-Z\d]/g, '');
                }
              "
            ></el-input>
          </el-form-item>

          <el-form-item prop="pwd">
            <div class="icon_all">
              <span class="icon">
                <img src="@/assets/images/UserLogin/icon-pwd.png" />
              </span>
              <span class="label">密码</span>
            </div>
            <!-- show-password -->
            <el-input
              :type="passw"
              v-model="ruleForm.pwd"
              maxlength="30"
              placeholder="请输入密码"
              @input="
                (v) => {
                  this.ruleForm.pwd = v.replace(
                    /[\u4E00-\u9FA5\uF900-\uFA2D\s]/g,
                    ''
                  );
                }
              "
            >
              <!-- <i slot="suffix" :class="icon" @click="showPass"></i> -->
            </el-input>
            <img class="iv_eye" src="@/assets/images/UserLogin/iv_eye_close.png" alt="" @click="showPass" v-if="passw != 'text'">
            <img class="iv_eye" src="@/assets/images/UserLogin/iv_eye_open.png" alt="" @click="showPass" v-if="passw == 'text'">
          </el-form-item>

          <el-form-item prop="baseReqDto">
            <div class="icon_all">
              <span class="icon">
                <img src="@/assets/images/UserLogin/icon-baseReqDto.png" />
              </span>
              <span class="label">图形验证码</span>
            </div>
            <el-input
              v-model="ruleForm.baseReqDto"
              placeholder="请输入验证码信息"
              maxlength="5"
              @input="
                (v) => {
                  this.ruleForm.baseReqDto = v.replace(/[^a-zA-Z\d]/g, '');
                }
              "
            ></el-input>
            <div class="imgcode">
              <img :src="imgCodePath" @click="onChangeCode" alt="imgcode" />
            </div>
          </el-form-item>

          <el-form-item prop="phone">
            <div class="icon_all">
              <span class="icon">
                <img src="@/assets/images/UserLogin/iv_phone.png" />
              </span>
              <span class="label">手机号</span>
            </div>
            <el-input
              v-model="ruleForm.phone"
              placeholder="请输入手机号码"
              maxlength="11"
              type="tel"
              @input="
                (v) => {
                  this.ruleForm.phone = v.replace(/[^\d]/g, '');
                }
              "
            ></el-input>
          </el-form-item>

          <el-form-item prop="message">
            <div class="icon_all">
              <span class="icon">
                <img src="@/assets/images/UserLogin/iv_message.png" />
              </span>
              <span class="label">短信验证码</span>
            </div>
            <el-input
              v-model="ruleForm.message"
              placeholder="请输入短信验证码"
              maxlength="6"
              @input="
                (v) => {
                  this.ruleForm.message = v.replace(/[^\d]/g, '');
                }
              "
            ></el-input>
            <div v-if="!timer" class="phonecode" @click="getMessage">
              发送验证码
            </div>
            <div v-else class="phonecode">{{ totleTime }}s</div>
          </el-form-item>

          <el-button
            type="text"
            class="forget_button"
            @click="btnForgetPswClick"
            >忘记密码？</el-button
          >

          <el-form-item class="login-btn">
            <el-button type="primary" @click="onSubmit">点击登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-dialog
      title="忘记密码"
      :visible.sync="showForgetPsw"
      :width="61.0 * docFontSize + 'px'"
      class="dialog_forget"
    >
      <div class="forget_area">
        <div class="content0">请联系<span>管理员</span></div>
        <div class="content1">电话：13911933670</div>
      </div>
      <div slot="footer">
        <el-button class="btn_done" type="primary" @click="btnDialogDone"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "./Mixins";
import { _getCaptchaBase64, _getPhoneMessage ,_validateCaptcha } from "@/api/UserLogin";
import { catchErr, environment } from "@/utils/utils";

export default {
  mixins: [mixin],

  data() {
    // 验证手机号
    var validatePhone = (rule, value, callback) => {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
        return;
      }
      callback();
    };
    return {
      rules: {
        account: [{ required: true, message: "帐号不能为空", trigger: "blur" }],
        pwd: [{ required: true, message: "密码不能为空", trigger: "blur" }],
        baseReqDto: [
          { required: true, message: "图形验证码不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
      },
      timer: null,
      totleTime: 60,
      showForgetPsw: false,
      imgCodeSucceed:false,
      environment: true,
      passw: "password",
    };
  },

  computed: {
    ruleForm() {
      let data = this.UserLogin.ruleForm;
      data.unit = window.localStorage.getItem("binyi_cms_unit");
      return data;
    },
    imgCodePath() {
      return this.UserLogin.imgCodePath;
    },
    loginSucceed() {
      return this.UserLogin.loginSucceed;
    }
  },
  created() {
    window.sessionStorage.clear();
      this.onChangeCode();
    this.environment = environment()

    document.title = '中广家书管理系统'
    //document.title = '中广训练管理系统'
  },

  methods: {
    //密码的隐藏和显示
    showPass() {
      //点击图标是密码隐藏或显示
      if (this.passw == "text") {
        this.passw = "password";
      } else {
        this.passw = "text";
      }
    },
    //密码失焦事件
    onBlur(){
         this.passw = "password";
         this.icon = "el-input__icon el-icon-view";
    },
    onSubmit() {
      if (
        this.$binyiTool.isNull(this.ruleForm.account) ||
        this.$binyiTool.isNull(this.ruleForm.pwd) ||
        this.$binyiTool.isNull(this.ruleForm.baseReqDto) ||
        this.$binyiTool.isNull(this.ruleForm.phone) ||
        this.$binyiTool.isNull(this.ruleForm.message)
      ) {
        this.$message.error("登录信息有误，请检查后重新输入");
        return;
      }
      this.sendLogin();
    },
    btnForgetPswClick() {
      this.showForgetPsw = true;
    },
    btnDialogDone() {
      this.showForgetPsw = false;
    },
    onChangeCode() {
      this.getCaptchaBase64();
    },
    async getMessage() {
      this.$refs.ruleForm.validate(async (res) => {
        if (res) {
          if (!this.imgCodeSucceed) {
            let [err, res] = await catchErr(
              _validateCaptcha({
                data: this.ruleForm.baseReqDto.toLowerCase(),
              })
            );
            if (err) {
              this.$message.error("图形验证码错误");
              this.getCaptchaBase64(); //重置验证码
              return false;
            } 
            this.imgCodeSucceed = true
          }
          // let [err1, res1] = await catchErr(
          //   _getCaptchaBase64({
          //     data: this.ruleForm.baseReqDto,
          //   })
          // );
          // if (err1) {
          //   this.$message.error("图形验证码错误");
          //   return;
          // }
          let data = {
            name: this.ruleForm.account,
            tel: this.ruleForm.phone,
          };
          let [err, res] = await catchErr(
            _getPhoneMessage({
              data: data,
            })
          );
          if (err) {
            this.$message.error(err.message || "发送失败");
          } else {
            this.$message.success("发送成功");
            this.timer = window.setInterval(() => {
              this.totleTime--;
              if (this.totleTime <= 0) {
                window.clearInterval(this.timer);
                this.timer = null;
                this.totleTime = 60;
              }
            }, 1000);
          }
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.FromLogin {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 1920px;
  /* margin: 138px auto 0; */
  display: flex;
  align-items: center;
  overflow: auto;

  .binyi-toolbar {
    position: absolute;
    top: 0;
    width: 100%;
    height: 80px;
    line-height: 80px;
    // background: rgba(255, 255, 255, 0.15);
    border-bottom: 1px solid #D8D8D8;

    // padding-left: 58px;
    .binyi-toolbar-icon {
      margin-left: 58px;
      width: 50px;
      height: 50px;
    }

    .binyi-toolbar-name {
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      vertical-align: middle;
      margin-left: 10px;
    }
  }

  .login_background {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .template-form-login-banner {
    width: 384px;
    height: 384px;
  }

  .template-form-login-banner_a {
    width: 480px;
    height: 420px;
  }

  .template-form-login-container-line {
    margin-left: 120px;
    width: 2px;
    height: 350px;
    background: linear-gradient(180deg, rgba(134, 207, 255, 0) 0%, #393939 58%, rgba(169, 210, 255, 0) 100%);
  }

  .template-form-login-container {
    margin-left: 110px;
    width: 500px;
    height: 605px;
    border-radius: 11px;
    box-sizing: border-box;

    .login_title {
      width: 180px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .login_welcome {
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2C90FF;
        height: 40px;
      }

      .iv_triangle {
        margin-top: 5px;
        width: 18px;
        height: 11px;
      }
    }

    .login_title_line {
      margin-left: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 30px;

      .login_title_line_blue {
        width: 160px;
        height: 2px;
        background: #2C90FF;
      }

      .login_title_line_gray {
        width: 320px;
        height: 2px;
        background: #ECECEC;
      }
    }

    .form_style {
      margin-left: 10px;
    }

    .icon_all {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 5px;
    }

    .iv_eye {
      width: 53px;
      height: 40px;
      position: absolute;
      padding-right : 20px;
      padding-left: 20px;
      padding-top: 16px;
      padding-bottom: 16px;
      box-sizing: border-box;
      right: 10px;
      bottom:0px;
    }

    .icon {
      display: inline-block;
      width: 21px;
      height: 20px;
      vertical-align: middle;
      line-height: 0;

      img {
        width: 21px;
        height: 20px;
      }
    }

    .label {
      margin-left: 10px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #050500;
      height: 22px;
      line-height: 22px;
    }

    .imgcode {
      position: absolute;
      right: 10px;
      bottom: 10px;
      width: 100px;
      background: rgba(62, 102, 255, 1);
      border-radius: 5px;

      img {
        width: 100px;
        height: 50px;
        cursor: pointer;
      }
    }

    .phonecode {
      position: absolute;
      right: 10px;
      bottom: 10px;
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #F66915;
      border-radius: 5px;
      color: #ffffff;
      cursor: pointer;
    }

    .forget_button {
      color: #F66915;
      font-size: 16px;
      padding: 0;
      margin-left: 405px;
    }

    .login-btn {
      margin-top: 30px;

      .el-button {
        width: 280px;
        height: 60px;
        border-radius: 5px;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        border: 0;
      }
    }
  }

  .dialog_forget {
    .forget_area {
      height: 268px;
      text-align: center;
      font-size: 28px;

      .content0, .content1 {
        color: #000000;
        height: 40px;
        line-height: 40px;
      }

      .content0 {
        padding-top: 79px;

        span {
          color: #0691FF;
        }
      }

      .content1 {
        margin-top: 30px;
      }
    }

    .btn_done {
      width: 100px;
      height: 40px;
    }
  }

  

}
</style>
<style lang="stylus">
.template-form-login-container {
  .el-form-item {
    margin-bottom: 20px;

    .el-form-item__content {
      line-height: 0;

      .el-input__inner {
        width: 480px;
        height: 40px;
        border: 0;
        border-bottom: 1px solid #EDEDED;
        border-radius: 0;
        padding: 0px;
      }
    }
  }
}
.FromLogin .el-icon-close:before {
    font-size: 24px;
}
</style>





// WEBPACK FOOTER //
// src/pages/UserLogin/components/FromLogin.vue